import { render, staticRenderFns } from "./modal_detallesMetodologia.vue?vue&type=template&id=185cf01f&"
import script from "./modal_detallesMetodologia.vue?vue&type=script&lang=js&"
export * from "./modal_detallesMetodologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports